import { render, staticRenderFns } from "./VectorMaps.vue?vue&type=template&id=52a2e49e"
import script from "./VectorMaps.vue?vue&type=script&lang=js"
export * from "./VectorMaps.vue?vue&type=script&lang=js"
import style0 from "./VectorMaps.vue?vue&type=style&index=0&id=52a2e49e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports